import "svelte/store";
export default class Filter {
    constructor() {
        this._tutorSelectValue = null;
        this._roomSelectValue = null;
        this._timetableSelectValue = null;
        this._dateSelectValue = null;
    }
    get tutorSelectValue() {
        return this._tutorSelectValue;
    }
    set tutorSelectValue(value) {
        this._tutorSelectValue = value;
    }
    get roomSelectValue() {
        return this._roomSelectValue;
    }
    set roomSelectValue(value) {
        this._roomSelectValue = value;
    }
    get timetableSelectValue() {
        return this._timetableSelectValue;
    }
    set timetableSelectValue(value) {
        this._timetableSelectValue = value;
    }
    get dateSelectValue() {
        return this._dateSelectValue;
    }
    set dateSelectValue(value) {
        this._dateSelectValue = value;
    }
}
